import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { ProjectLayout } from './components/ProjectLayout'
import { Login } from './routes/Login'
import { Groups } from './routes/Groups'
import { ProjectHome } from './routes/ProjectHome'
import { DocumentView } from './routes/DocumentView'
import { DocumentEdit } from './routes/DocumentEdit'
import { DocumentVersions } from './routes/DocumentVersions'
import { Trash } from './routes/Trash'
import { OAuthLoading } from './routes/OAuthLoading'
import { OAuthCallback } from './routes/OAuthCallback'
import { OAuthConsent } from './routes/OAuthConsent'

export function App() {
  return (
    <Routes>
      {/* Login + OAuth 흐름 페이지는 shell 바깥 (nav 미표시) */}
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/loading" element={<OAuthLoading />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />
      <Route path="/oauth/consent" element={<OAuthConsent />} />

      {/* 그 외 모든 라우트는 AppShell 안에서 — TopNav + GlobalLoadingBar 가 라우트 전환에도 그대로 유지 */}
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/groups" replace />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/trash" element={<Trash />} />

        {/* 프로젝트 안에서는 Sidebar 가 layout 으로 항상 마운트, 본문만 라우트 따라 교체.
         *  문서 상세는 /d/:uuid — ProjectLayout 이 doc 의 projectKey 로 사이드바 resolve. */}
        <Route element={<ProjectLayout />}>
          <Route path="/projects/:projectKey" element={<ProjectHome />} />
          <Route path="/d/:uuid" element={<DocumentView />} />
          <Route path="/d/:uuid/edit" element={<DocumentEdit />} />
          <Route path="/d/:uuid/versions" element={<DocumentVersions />} />
        </Route>

        <Route path="*" element={<Navigate to="/groups" replace />} />
      </Route>
    </Routes>
  )
}
